<template>
  <div class="replacementmonthlystatistics__report__view">   
    <div class="box is-primary">
      <h2 class="title is-3">
        Overblikssiden
        
        <b-select v-model="regionFilter" expanded @input="filterRegions">
          <option v-for="(item, index) in regions" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </b-select>  
      </h2>
      <div class="columns">
          <div class="column">
            <h3>Afløser anmodninger</h3>
              <section class="personal-info">        
                <b-field label="Vis alle anmodninger"
                        class="column">
                  <div class="fake-control" style="width: 200px">
                    <b-switch v-model="showAll"
                              type="is-primary"
                              size="is-medium">{{showAll ? 'Ja' : 'Nej'}}</b-switch>
                  </div>
                </b-field>
              </section>
            <b-table :data="filteredNotifications"
                      :loading="loading"
                      hoverable>
              <b-table-column field="employeeName"
                              label="Ins."
                              v-slot="props">
                {{ getStateLabel(props.row.state) }}        
              </b-table-column>

              <b-table-column field="employeeName"
                              label="Ins."
                              v-slot="props">
                {{ props.row.employeeName }}              
              </b-table-column>
              <b-table-column field="replacementName"
                              label="Afløser"
                              v-slot="props">
                {{ props.row.allocation ? props.row.allocation.replacementName : '' }}              
              </b-table-column>
              <b-table-column field="circleName"
                              label="Kreds/Opg."
                              v-slot="props">
                {{ props.row.circleName }}                
              </b-table-column>
              <b-table-column field="date"
                              label="Dato"
                              v-slot="props">
                <a @click="openSidebar(props.row.allocation)">
                  {{ props.row.date | formatDate }}                
                </a>
              </b-table-column>
             </b-table>
          </div>
      </div>

      <div class="columns">
          <div class="column">
            <h3>Afløsere i dag</h3>
            <b-table :data="filteredReplacements"
                      :loading="loading"
                      hoverable>

              <b-table-column field="employeeName"
                              label="Ins."
                              v-slot="props">
                <a @click="gotoCalenderReplacement(props.row)" href="javascript:void(0)">{{ props.row.number }}</a> - {{ props.row.name }}              
              </b-table-column>
              <b-table-column field="type"
                              label="Status i dag"
                              v-slot="props">
                <div :class="[colorMap(props.row, 0)]">
                  {{ replacementAllocationLabel(props.row.id, 0) }}
                </div>
              </b-table-column>
              <b-table-column field="who"
                              label="Ins."
                              v-slot="props">
                {{ replacementAllocation(props.row.id) ? replacementAllocation(props.row.id).employeeName : ''  }}
              </b-table-column>
              <b-table-column field="circleName"
                              label="Kreds/Opgave"
                              v-slot="props">
                {{ replacementAllocation(props.row.id) ? replacementAllocation(props.row.id).circleName : ''  }}
              </b-table-column>
              <b-table-column field="circleName"
                              label="Kommentar"
                              v-slot="props">
                {{ replacementAllocation(props.row.id) ? replacementAllocation(props.row.id).comment : ''  }}
              </b-table-column>
              <b-table-column field="type"
                              label="Status i morgen"
                              v-slot="props"
                              cellClass="table-tomorrow">
                <div :class="[colorMap(props.row, 1)]">
                {{ replacementAllocationLabel(props.row.id, 1) }}
                </div>
              </b-table-column>
              <b-table-column field="who"
                              label="Ins. i morgen/Opgave"
                              v-slot="props"
                              cellClass="table-tomorrow">
                {{ replacementAllocationAddDays(props.row.id, 1) ? replacementAllocationAddDays(props.row.id, 1).employeeName : ''  }}
              </b-table-column>
              <b-table-column field="who"
                              label="kreds/Opgave"
                              v-slot="props"
                              cellClass="table-tomorrow">
                {{ replacementAllocationAddDays(props.row.id, 1) ? replacementAllocationAddDays(props.row.id, 1).circleName : ''  }}
              </b-table-column>
             </b-table>
          </div>
      </div>
      <!-- <div class="columns">          
          <div class="column">
            <h3>Inseminørgrupper i dag og i morgen</h3>
            <b-table :data="filteredGroups"
                      :loading="loading"
                      hoverable>

              <b-table-column field="title"
                              label="Gruppe"
                              v-slot="props">  
                <a @click="gotoCalender(props.row)" href="javascript:void(0)">
                {{ props.row.title }}               
                </a>            
              </b-table-column>
              <b-table-column field="ins"
                              label="Fri ins."
                              v-slot="props">
                {{ groupAllocation(props.row.id, 0) }}
              </b-table-column>
              <b-table-column field="grpComment"
                              label="Grp. kommentar"
                              v-slot="props">
                {{ groupComment(props.row.id, 0)  }}
              </b-table-column>
              <b-table-column field="insTomorrow"
                              label="Fri ins. i morgen"
                              v-slot="props"
                              cellClass="table-tomorrow">
                {{ groupAllocation(props.row.id, 1) }}
              </b-table-column>
              <b-table-column field="grpCommentTomorrow"
                              label="Grp. kommentar"
                              v-slot="props"
                              cellClass="table-tomorrow">
                {{ groupComment(props.row.id, 1)  }}
              </b-table-column>
             </b-table>
          </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../enums/APISTATE";
import moment, { ISO_8601 } from 'moment';

export default {
  name: 'dashboard-view',
  components: { },
  data: () => ({ 
    regionFilter: null,
    calendarData: [],
    editing: undefined,
    showAll: false
  }),
  async mounted() {
    
    if(localStorage.regionFilter) {
      this.regionFilter = (localStorage.regionFilter === 'null' ? null : localStorage.regionFilter);
    }
    await this.$store.dispatch('metadata/initialize');
    await this.loadReplacements();
    await this.getAllocationDashboard();
    let start = await this.viewStartDate();
    let end = await this.viewToDate();
    
    let requestNotification = { startDate: start, endDate: end, forRegion: null };
    await this.getNotificationsForPeriod(requestNotification);
    await this.loadEmployees();
    await this.getAllGroups();
    
    var today = moment.utc(new Date()).toDate();
    var tomorrow = moment.utc(new Date()).add(1, 'days').toDate();
    await this.loadGroupCommentsDashboard({fromDate: today, toDate: tomorrow });
  },
  methods: {
    ...mapActions("notificationStore", ["getNotificationsForPeriod", "updateNotification", "setNotificationOnStore"]),
    ...mapActions("entrySidebar", ["entrySidebarOpen", "entrySidebarOpenAsync"]),
    ...mapActions("employees", ["loadReplacements", "loadEmployees"]),
    ...mapActions("allocations", ["getAllocationDashboard"]),
    ...mapActions("groupStore", ["getAllGroups"]),
    ...mapActions("groupComments", ["loadGroupCommentsDashboard"]),
    async viewStartDate() { 
      var startDate = moment.utc(new Date());
      startDate = startDate.add(-startDate.isoWeekday() + 2, 'days');
      return startDate.toDate();
    },
    async viewToDate() {    
      let start = await this.viewStartDate();
      return moment(start).add(3, 'weeks').toDate();
    },
    filterRegions(region) {
      this.regionFilter = region;
      localStorage.regionFilter = region;
    },
    getStateLabel(state) {
      if(state === 0) {
        return 'Ny';
      }
      if(state === 1) {
        return 'Venter';
      }
      if(state === 2) {
        return 'Godkendt';
      }
      return 'Afvist';
    },
    gotoCalender(entry){      
      if(entry && entry.title) {
        localStorage.groupFilter = entry.id;
        this.$router.push({ name: 'Schedule' })
      }      
    },
    gotoCalenderReplacement(entry){      
      if(entry) {
        localStorage.employeeFilter = entry.number;
        localStorage.groupFilter = null;
        this.$router.push({ name: 'Schedule' })
      }      
    },
    groupAllocation(entry, idx) {
      let employees = this.employees.filter(o => o.groupId === entry && (o.region === this.regionFilter ||!this.regionFilter) && o.role !== "Replacements");
      // TODAY
      if(idx === 0) {
        var today = moment.utc(new Date()).format('YYYY-MM-DD');

        let allocations = this.allocationsDashboard.filter(o => moment(o.startDate).format('YYYY-MM-DD') === today || 
        (o.allocationSpanInDays > 1 && moment(o.startDate).format('YYYY-MM-DD') <= today && today <= moment(o.endDateInclusive).format('YYYY-MM-DD')));
        
        let result = "";

        for(let e of employees) {
          let tmp = allocations.filter(o => o.employeeId === e.id && o.allocationType === "WORK");
          if(tmp.length === 0) {
            result = `${e.name}. ${result}`;
          }
        }

        return result;
      }

      var tomorrow = moment.utc(new Date()).add(idx, 'days').format('YYYY-MM-DD');

      let allocations = this.allocationsDashboard.filter(o => moment(o.startDate).format('YYYY-MM-DD') === tomorrow || 
        (o.allocationSpanInDays > 1 && moment(o.startDate).format('YYYY-MM-DD') <= tomorrow && tomorrow <= moment(o.endDateInclusive).format('YYYY-MM-DD')));
      let result = "";

      for(let e of employees) {
        let tmp = allocations.filter(o => o.employeeId === e.id && o.allocationType === "WORK");
        if(tmp.length === 0) {
          result = `${e.name}. ${result}`;
        }
      }

      return result;
    },
    groupComment(entry, idx) {
      // TODAY
      if(idx === 0) {
        var today = moment.utc(new Date()).format('YYYY-MM-DD');

        let comments = this.groupCommentsDashboard.filter(o => moment(o.date).format('YYYY-MM-DD') === today && o.groupId === entry);
        
        let result = "";

        for(let e of comments) {
            result = `${e.comment}. ${result}`;
        }

        return result;
      }

      var tomorrow = moment.utc(new Date()).add(idx, 'days').format('YYYY-MM-DD');
 
      let comments = this.groupCommentsDashboard.filter(o => moment(o.date).format('YYYY-MM-DD') === tomorrow && o.groupId === entry);
      let result = "";

      for(let e of comments) {
          result = `${e.comment}. ${result}`;
      }

      return result;
    },
    replacementAllocationLabel(entry, i){
      let allocation = this.replacementAllocationAddDays(entry, i);

      if(!allocation){
        var newDate = moment.utc(new Date()).add(i, 'days').format('YYYY-MM-DD');
        allocation = this.allocationsDashboard
          .filter(o => moment(o.startDate).format('YYYY-MM-DD') <= newDate)
          .filter(o => moment(o.endDateInclusive).format('YYYY-MM-DD') >= newDate)
          .find(o => (o.employeeId === entry || o.replacementId === entry) && !o.circleId);
      }
      
      if(allocation) {
        if(!allocation.circleId) {
          return this.allocationTypes[allocation.allocationType];
        }

        return 'Arbejder';
      }

      return 'Ledig';
    },
    replacementAllocation(entry) {      
      let allocations = this.allocationsDashboard.filter(o => (o.employeeId === entry || o.replacementId === entry) && o.circleId);
      if(!allocations || allocations.length === 0){
        return null;
      }
      
      var today = moment.utc(new Date()).format('YYYY-MM-DD');

      allocations = allocations.filter(o => moment(o.startDate).format('YYYY-MM-DD') === today);
      if(!allocations || allocations.length === 0){
        return null;
      }

      if(allocations.indexOf(o => o.replacementId === entry) !== -1) {
        return allocations.filter(o => o.replacementId === entry)[0];
      }

      return allocations[0];
    },
    replacementAllocationAddDays(entry, i) {      
      let allocations = this.allocationsDashboard.filter(o => (o.employeeId === entry || o.replacementId === entry) && o.circleId);
      if(!allocations || allocations.length === 0){
        return null;
      }
      
      var newDate = moment.utc(new Date()).add(i, 'days').format('YYYY-MM-DD');

      allocations = allocations      
          .filter(o => moment(o.startDate).format('YYYY-MM-DD') <= newDate)
          .filter(o => moment(o.endDateInclusive).format('YYYY-MM-DD') >= newDate);
          
      if(!allocations || allocations.length === 0){
        return null;
      }

      if(allocations.indexOf(o => o.replacementId === entry) !== -1) {
        return allocations.filter(o => o.replacementId === entry)[0];
      }

      return allocations[0];
    },
    async openSidebar(entry) {
      entry.canEdit = true;
      let notification = this.notifications.find(o => o.allocationId === entry.id);

      if(notification) {
        this.setNotificationOnStore(notification);
      }

      await this.entrySidebarOpenAsync(entry).then(async (response) => {
        if(response.action === "update") {
          //console.log(response);
          const { model } = response;
          
          let notification = this.notifications.find(o => o.allocationId === model.id);

          if(this.notification) {
            notification = this.notification;
          }

          if(notification) {
            notification.allocation = model; // Set new data
            await this.updateNotification(notification);
            let start = await this.viewStartDate();
            let end = await this.viewToDate();
            let requestNotification = { startDate: start, endDate: end, forRegion: null };
            await this.getNotificationsForPeriod(requestNotification);
          }

        }
      }).catch((error) => console.error(error));
    },
    colorMap(arg, i){
      let allocation = this.replacementAllocationAddDays(arg.id, i);

      if(!allocation){
        var newDate = moment.utc(new Date()).add(i, 'days').format('YYYY-MM-DD');
        allocation = this.allocationsDashboard
          .filter(o => moment(o.startDate).format('YYYY-MM-DD') === newDate)
          .find(o => (o.employeeId === arg.id || o.replacementId === arg.id) && !o.circleId);
      }

      if(allocation) {
        if(allocation.allocationType === "OFFDAY") {
          return "yellow";
        }
        if(allocation.allocationType === "VACATION") {
          return "black";
        }

        return allocation.circleColor;
      }

      return 'white';
    },
  },
  computed: {
    ...mapGetters("notificationStore", ["notificationApiState", "notification", "notifications"]),
    ...mapGetters("allocations", ["allocationDashboardApiState", "allocationsDashboard"]),
    ...mapGetters('employees', ['replacementApiState','replacements', 'employeeApiState', 'employees']),
    ...mapGetters('groupStore', ['groupApiState','groups']),
    ...mapGetters('groupComments', ['groupCommentsApiStateDashboard','groupCommentsDashboard']),
    ...mapGetters('metadata', ['allocationTypes', 'regions']),
    loading() {
      return this.notificationApiState !== ApiState.LOADED && 
      this.replacementApiState !== ApiState.LOADED && 
      this.employeeApiState !== ApiState.LOADED && 
      this.groupCommentsApiStateDashboard !== ApiState.LOADED;
    },
    filteredReplacements() {
      if(this.replacements) {
        if(this.regionFilter) {
          let filtered = this.replacements
            .filter(o => o.region === "begge" || o.region === this.regionFilter)
            .filter(o => o.isActive);

          if(filtered) {
            return filtered;
          }
        } else {
          let filtered = this.replacements
            .filter(o => o.isActive);
          console.log(filtered);
          if(filtered) {
            return filtered;
          }
        }
      }
      return this.replacements;
    },
    filteredGroups() {
      if(this.groups && this.regionFilter) {
        let filtered = this.groups.filter(o => o.region === "begge" || o.region === this.regionFilter);

        if(filtered) {
          return filtered;
        }
      }
      return this.groups;
    },
    filteredNotifications() {
      if(this.notifications) {
        let filtered = this.notifications
        .filter(o => this.showAll || o.state !== 2)
        .filter(o => this.showAll || o.state !== 1 || moment(o.onHoldUntilDate) < moment(new Date()));

        if(this.regionFilter){
          filtered = filtered.filter(o => o.region === "begge" || o.region === this.regionFilter);
        }
        
        if(filtered) {
          return filtered;
        }
      }
      return this.notifications;
    }
  }
}
</script>

<style lang="scss" scoped>
  table td {
    text-align: left !important;
  }
  .table-tomorrow {
    background: #cbf1ff;
  }
div.blue {
  background: rgba(0, 70, 150, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.orange {
  background-color: rgba(250, 100, 0, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.purple {
  background:rgba(120, 50, 140, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.magenta {
  background-color: rgba(210, 40, 100, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.red {
  background-color: rgba(210, 10, 10, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.gray  {
  background-color: rgba(136, 136, 136, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.black {
  background-color: rgba(34, 34, 34, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
div.aqua {
  background-color: rgba(60, 160, 200, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

div.green {
  background-color: rgba(30, 140, 10, 0.8);
  color: white;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}

div.yellow {
  background-color: rgba(246, 255, 0, 0.8);
  color: black;
  padding: 0.5em 0.75em;
  margin: -0.5em -0.75em;
}
</style>